import React, { useState } from 'react';
import { Lock, Mail, User } from 'lucide-react';
import Header from '../component/Header';
import Footer from '../component/Footer';
import { useAuth } from '../context/AuthContext';
import { changePassword } from '../services/authService';

const AdminProfile = () => {
  const { currentUser } = useAuth();
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  const submitPasswordChange = async (event: React.FormEvent) => {
    event.preventDefault();
    setMessage('');
    if (!oldPassword || !newPassword || !confirmPassword) {
      setMessage('Complete all password fields.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setMessage('New passwords do not match.');
      return;
    }

    const token = localStorage.getItem('token');
    if (!token) return;
    setIsSaving(true);
    try {
      const response = await changePassword(token, { old_password: oldPassword, new_password: newPassword });
      setMessage(response.message || 'Password changed successfully.');
      setOldPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (error) {
      setMessage(error instanceof Error ? error.message : 'Unable to change password.');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <>
      <Header />
      <main className="min-h-screen bg-[#fcfaf8] px-6 pb-16 pt-28 font-sans text-zinc-900">
        <div className="mx-auto max-w-2xl">
          <p className="text-xs font-black uppercase tracking-widest text-amber-600">Admin</p>
          <h1 className="mt-2 text-4xl font-black tracking-tight">Profile</h1>

          <section className="mt-8 rounded-3xl border border-zinc-200 bg-white p-7 shadow-sm">
            <div className="flex items-center gap-4 border-b border-zinc-100 pb-6">
              <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-amber-500 text-zinc-950"><User className="h-5 w-5" /></span>
              <div><p className="font-black text-zinc-900">{currentUser?.name || 'Admin'}</p><p className="mt-1 flex items-center gap-1.5 text-sm text-zinc-500"><Mail className="h-4 w-4" /> {currentUser?.email || '—'}</p></div>
            </div>

            <form onSubmit={submitPasswordChange} className="mt-7 space-y-4">
              <div className="flex items-center gap-2"><Lock className="h-4 w-4 text-amber-600" /><h2 className="font-black text-zinc-900">Change password</h2></div>
              <input required type="password" value={oldPassword} onChange={(event) => setOldPassword(event.target.value)} placeholder="Current password" className="w-full rounded-xl border border-zinc-300 px-4 py-3 text-sm" />
              <input required type="password" value={newPassword} onChange={(event) => setNewPassword(event.target.value)} placeholder="New password" className="w-full rounded-xl border border-zinc-300 px-4 py-3 text-sm" />
              <input required type="password" value={confirmPassword} onChange={(event) => setConfirmPassword(event.target.value)} placeholder="Confirm new password" className="w-full rounded-xl border border-zinc-300 px-4 py-3 text-sm" />
              {message && <p className="text-sm font-medium text-zinc-600">{message}</p>}
              <button disabled={isSaving} className="rounded-xl bg-zinc-950 px-5 py-3 text-xs font-black uppercase tracking-widest text-white disabled:opacity-60">{isSaving ? 'Saving…' : 'Update password'}</button>
            </form>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default AdminProfile;
